import $ from 'jquery';

$('iframe').on('load', () => {
  return window.__vimeoRefresh?.();
});
